export default "__VITE_ASSET__749d62c8__"